import Vue from 'vue'
import Router from 'vue-router'

import global from '@/core/global/global.js'

var param = global.global.getParam();


Vue.use(Router);

import configuration from './configuration'
import mobileyd from './mobileyd'
var routes = (branches) => {
  var merge = [];
  branches.map(function (item) {
    merge.push.apply(merge, item);
  })
  return merge;
}
 var RouteSrc = []
if(global.global.ispc) {
  RouteSrc = [configuration]
}else {
  RouteSrc = [mobileyd]

}

const router = new Router({
  routes: routes(RouteSrc),
  mode: 'history',
  base: process.env.BASE_URL,

})
export default router
router.beforeEach((to, from, next) =>{
  // 判断是否从其他网站进入,看是否登录
  if(to.query.hasOwnProperty("token")) {
    let token = to.query.token
    if(token !== '' || token !== 'null'){
      sessionStorage.setItem("token",token);
    }
  }
  next()
})